import { Card, CardContent } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { cardSx } from './ds';

interface FormCardProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const FormCard = ({ children, sx }: FormCardProps) => (
  <Card sx={{ ...cardSx, mb: 3, ...sx }}>
    <CardContent sx={{ p: 3 }}>
      {children}
    </CardContent>
  </Card>
);

export default FormCard;
